import { AttendanceAction } from "__generated__/graphql"

export const ATTENDANCE_ACTION_GROUPS = {
  chat: new Set<AttendanceAction>([AttendanceAction.CheckInChat, AttendanceAction.CheckOutChat]),
  checkInOut: new Set<AttendanceAction>([AttendanceAction.CheckIn, AttendanceAction.CheckOut]),
  overtime: new Set<AttendanceAction>([
    AttendanceAction.CheckInOt,
    AttendanceAction.CheckInPt,
    AttendanceAction.CheckOutOt,
    AttendanceAction.CheckOutPt,
  ]),
}

export const ATTENDANCE_ACTION_PAIRS = [
  [AttendanceAction.CheckIn, AttendanceAction.CheckOut],
  [AttendanceAction.CheckInOt, AttendanceAction.CheckOutOt],
  [AttendanceAction.CheckInPt, AttendanceAction.CheckOutPt],
  [AttendanceAction.CheckInChat, AttendanceAction.CheckOutChat],
] as const

export const ATTENDANCE_ACTION_LABELS: Record<AttendanceAction, string> = {
  [AttendanceAction.CheckIn]: "Check-in",
  [AttendanceAction.CheckInChat]: "Bắt đầu trực chat",
  [AttendanceAction.CheckInOt]: "Bắt đầu OT",
  [AttendanceAction.CheckInPt]: "Bắt đầu PT",
  [AttendanceAction.CheckOut]: "Check-out",
  [AttendanceAction.CheckOutChat]: "Kết thúc trực chat",
  [AttendanceAction.CheckOutOt]: "Kết thúc OT",
  [AttendanceAction.CheckOutPt]: "Kết thúc PT",
  [AttendanceAction.Leave]: "Nghỉ",
}
